export default "<canvas id=\"items-available-chart\"></canvas>\r\n"